import type { JournalRule } from './types';

const modules = import.meta.glob('./rules/*.json', { eager: true, import: 'default' }) as Record<
	string,
	JournalRule
>;

export const JOURNALS: JournalRule[] = Object.values(modules).sort((a, b) =>
	a.name.localeCompare(b.name)
);

export function getJournal(id: string | null | undefined): JournalRule | null {
	if (!id) return null;
	return JOURNALS.find((j) => j.id === id) ?? null;
}

export function searchJournals(query: string): JournalRule[] {
	const q = query.trim().toLowerCase();
	if (!q) return JOURNALS;
	return JOURNALS.filter(
		(j) =>
			j.name.toLowerCase().includes(q) ||
			j.publisher.toLowerCase().includes(q) ||
			j.id.toLowerCase().includes(q)
	);
}
